import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { installAutocapture } from './lib/runtime';
import { installUiAutocapture, getPostHog } from './lib/analytics';
import { initPwaUpdate } from './lib/pwa-update';
import { PostHogProvider } from 'posthog-js/react';
import './styles/index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root');

// Service-worker update orchestration. Registers the SW with custom
// callbacks, polls for new builds, and either reloads silently
// (hidden tab) or fires `synfolio:update-available` (visible tab,
// banner shows). See src/web/lib/pwa-update.ts.
initPwaUpdate();

// UI Instrumentation runtime (existing) — fires a custom UI event
// on click. Lightweight; runs regardless of analytics setup.
installAutocapture();

// PostHog autocapture — delegated click listener that translates any
// data-ui-action click into a `ui_interaction` event with the merged
// entity context. No-op if VITE_POSTHOG_KEY is unset, so dev/local
// builds don't have to ship a key.
installUiAutocapture();

const ph = getPostHog();

createRoot(root).render(
  <React.StrictMode>
    {ph ? (
      <PostHogProvider client={ph}>
        <App />
      </PostHogProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>,
);
